import {
  AlertTriangle,
  Coins,
  Flag,
  Link,
  MessageChatSquare,
} from "../../ui/Icon/Icon";
import PurchaseCreditsModal from "../../pages/Settings/Billing/CreditsCard/PurchaseCreditsModal/PurchaseCreditsModal";
import ChangePlanModal from "../../pages/Settings/Billing/PlanCard/ChangePlanModal/ChangePlanModal";
import TileButton from "../../ui/TileButton/TileButton";
import useUser from "../../providers/UserProvider/useUser";
import { useDisclosure } from "../../ui/util/useDisclosure";
import Modal from "../../ui/Modal/Modal";
import styles from "./SecondTeamWarningModal.module.scss";

function SecondTeamWarningModal({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  const { userOrganizations } = useUser();

  const [purchaseCreditsModalOpened, purchaseCreditsModal] = useDisclosure();
  const [changePlanModalOpened, changePlanModal] = useDisclosure();

  return (
    <>
      <PurchaseCreditsModal
        isOpen={purchaseCreditsModalOpened}
        onClose={purchaseCreditsModal.close}
      />
      <ChangePlanModal
        isOpen={changePlanModalOpened}
        onClose={changePlanModal.close}
      />
      <Modal
        title="You have no article credits"
        isOpen={isOpen}
        onClose={onClose}
      >
        <div className={styles.mobileWarningBody}>
          <AlertTriangle size="large" className={styles.mobileWarningIcon} />
          <p>
            Unfortunately we only provide free credits for your first account.
            If you would like to test Macaw with a new website, please get in
            touch and we&apos;ll be happy to issue some free credits.
          </p>
        </div>

        <div className={styles.buttons}>
          <TileButton
            IconComponent={MessageChatSquare}
            onClick={() => {
              window.Intercom("showNewMessage");
              onClose();
            }}
            title="Request free trial credit"
            subtitle="For trialing a new site"
          />
          <TileButton
            IconComponent={Flag}
            onClick={() => {
              changePlanModal.open();
              onClose();
            }}
            title="View plans"
            subtitle="Subscribe to a plan"
          />
          <TileButton
            IconComponent={Coins}
            onClick={() => {
              purchaseCreditsModal.open();
              onClose();
            }}
            title="Purchase extra credits"
            subtitle="Pay as you go"
          />
          {userOrganizations && userOrganizations.length > 1 && (
            <TileButton
              IconComponent={Link}
              onClick={() => {
                window.open(
                  "https://docs.macawhq.com/en/articles/9900973-linked-teams",
                  "_blank",
                );
                onClose();
              }}
              title="Link existing team"
              subtitle="Share credits from another team"
            />
          )}
        </div>
      </Modal>
    </>
  );
}

export default SecondTeamWarningModal;
